export default __webpack_public_path__ + "static/media/mobile.fce7da43.png";